import _ from 'lodash';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Loading from '../../../shared/loading';
import { Container, ContentContainer } from '../shared/styles';
import CompaniesContext, { reducer, defaultState } from './companies-components/context';
import { useGetCompanies, createCompanyCTA, updateCompanyCTA } from '../../../services/lwadmin/company/company-service';
import Header from './companies-components/header';
import Company from './companies-components/company';
import Actions from './companies-components/actions';
import EditCompanyModal from './companies-components/edit-company-modal';
import BrandCompanyModal from './companies-components/brand-company-modal';
import CTAModal from './companies-components/cta-modal';

const initialOrder = 'asc';

export default function Companies() {
  const [{ loading }, get] = useGetCompanies();
  const [state, dispatch] = React.useReducer(reducer, defaultState);
  const loadingRef = React.useRef();

  const sortCompanies = React.useCallback((companies, key, direction) => {
    const c = _.orderBy(companies, key, direction);
    dispatch({ type: 'setCompanies', payload: c });
  }, []);

  useChangeAwareEffect(({ isMount }) => {
    isMount && get().then(({ data }) => {
      const companies = _.get(data, 'companies') || [];
      sortCompanies(companies, 'name', initialOrder);
    });
  }, {});

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  const onSort = (key, direction) => {
    sortCompanies(state.companies, key, direction);
  };

  const props = { initialOrder, onSort };

  return (
    <ThemeProvider theme={theme}>
      <CompaniesContext.Provider value={{ state, dispatch }}>
        <Container>
          <ContentContainer>
            <h1>Companies</h1>
            <Header {...props} />
            <Loading ref={loadingRef}>
              {state.companies.map(company => <Company key={company.id} company={company} />)}
            </Loading>
            <EditCompanyModal />
            <BrandCompanyModal />
            <CTAModal
              type="company"
              title="Create Company CTA"
              description="Create a CTA preset for all Company contributors. This CTA can be added to a wire from the Preset List in the Wire Editor. Changing a Preset from the Editor will not alter this default. Previously published wires remain unaffected."
              dispatchEvent="companyUpdated"
              createFunction={createCompanyCTA}
              updateFunction={updateCompanyCTA}
            />
          </ContentContainer>
          <Actions />
        </Container>
      </CompaniesContext.Provider>
    </ThemeProvider>
  );
}
